export const handleOutsideClick = (event: any, ref: any, setter: any, ref2: any) => {
  if (ref.current && !ref.current.contains(event.target) && ref2.current && !ref2.current.contains(event.target)) {
    setter(false);
  }
};